import { FC } from "react";
import { StyledDatetimeButton } from "./DatetimeButton.styles";
import { AllieDatetimeButtonProps } from "./DatetimeButton.types";

export const AllieDatetimeButton: FC<AllieDatetimeButtonProps> = (props) => <StyledDatetimeButton {...props} />;
